import { Mixins, Component } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import User from '@/views/User/models/user'

@Component({ inheritAttrs: false })
export default class Language extends Mixins<MixinInterface>() {
    loading = false
    get languages() {
        return Object.values(this.$store.getters.languages).filter((language: any) => {
            return language.availableForUsers
        })
    }

    get language() {
        return this.$store.getters.userLanguage
    }

    set language(data: string) {
        if (this.isAuthenticated) {
            this.patchUser(data)
        } else {
            this.$store.commit('userLanguage', data)
        }
    }

    async patchUser(language: string) {
        this.loading = true
        let data = {
            type: 'user',
            id: this.currentUser.id,
            attributes: {
                language: language,
            },
        }

        await User.patchCurrentUser(data, this.$store.getters.user.attributes.updatedAt).catch(
            async (error: any) => {
                if (error.data.response.status === 412) {
                    await this.getUser(this.$store.getters.user.id).catch(() => {
                        //
                    })

                    await this.patchUser(language)
                }
            }
        )
        this.loading = false
    }
}
